import { render, staticRenderFns } from "./freight-detail.vue?vue&type=template&id=4c458ffa&scoped=true&"
import script from "./freight-detail.vue?vue&type=script&lang=js&"
export * from "./freight-detail.vue?vue&type=script&lang=js&"
import style0 from "./freight-detail.vue?vue&type=style&index=0&id=4c458ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c458ffa",
  null
  
)

export default component.exports